module.exports = __webpack_public_path__ + "spinner-light.02ab2b7a.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/decorative/spinner-light.png
// module id = ./public/assets/images/decorative/spinner-light.png
// module chunks = main